// frontend/utils/environment.js
export const isDevelopment = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('debug') === 'true') {
    return true;
  } else {
    return false;
  }
};